<template>
  <div class="user-info-container">
    <div class="title">个人信息</div>
    <div class="add-member" v-if="!isMember&&!editData">
      <div class="add-text">加入Thom Browne会员 畅享丰富权益</div>
      <div class="add-now" @click="showAdd=true">立即加入会员</div>
    </div>
    <div class="see-member" @click="showSee = true" v-if="isMember&&!editData">查看会员权益</div>

    <div class="content" v-if="!editData">
      <div>
        <div class="item">
          <div class="label">称谓</div>
          <div class="value" v-if="showuserinfo.gender == 0">未知</div>
          <div class="value" v-if="showuserinfo.gender == 1">先生</div>
          <div class="value" v-if="showuserinfo.gender == 2">女士</div>
        </div>
        <div class="item two">
          <div class="label">姓氏</div>
          <div class="value">{{showuserinfo.name ? showuserinfo.name:"---"}}</div>
        </div>
        <div class="item two">
          <div class="label">名字</div>
          <div class="value">{{showuserinfo.firstName ? showuserinfo.firstName:"---"}}</div>
        </div>
        <div class="item">
          <div class="label">邮箱地址</div>
          <div class="value">{{showuserinfo.email ?showuserinfo.email:'---'}}</div>
        </div>
        <div class="item">
          <div class="label">电话</div>
          <div class="value">{{showuserinfo.phoneNumber ? showuserinfo.phoneNumber:'---'}}</div>
        </div>
        <div class="item">
          <div class="label">生日</div>
          <div class="value">{{showuserinfo.birthday ? showuserinfo.birthday:'---'}}</div>
        </div>
      

        <div class="edit-btn" @click="editUserInfo()">编辑</div>
      </div>
    </div>

      <div class="content edit-content" v-else>
      <Form class="edit" ref="formValidate" :model="userInfo" :rules="ruleValidate">
        <FormItem prop="gender" class="edit-item">
          <div class="data">
            <div class="label">称谓*</div>
            <Select v-model="userInfo.gender" style="width:100%">
              <Option v-for="item in sexs" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </div>
        </FormItem>
        <FormItem prop="name" class="edit-item lastName namesings two">
          <div class="data">
            <div class="label">姓氏*</div>
            <Input type="text" v-model="userInfo.name" />
          </div>
        </FormItem>
        <FormItem prop="firstName" class="edit-item namesings two">
          <div class="data">
            <div class="label">名字*</div>
            <Input type="text" v-model="userInfo.firstName" />
          </div>
        </FormItem>
        <FormItem prop="email" class="edit-item">
          <div class="data">
            <div class="label">电邮*</div>
            <Input type="text" :readonly="ishasEmail" v-model="userInfo.email" />
          </div>
        </FormItem>

        <FormItem prop="phoneNumber" class="edit-item phone-item two">
          <div class="data">
            <div class="label">电话号码*</div>
            <Input type="number" :readonly="userInfo.phoneNumber" v-model="userInfo.phoneNumber" />
          </div>
        </FormItem>
        <!-- <FormItem class="edit-item two">
          <div class="des">如果我们需要就您的订单与您联系</div>
        </FormItem> -->

        <FormItem class="edit-item two">
          <div class="data">
            <div class="label">生日</div>
            <!-- <Input type="text" /> -->
            <DatePicker
              v-model="userInfo.birthday"
              :options="dateOptions"
              format="MM/dd/yyyy"
              type="date"
            ></DatePicker>
          </div>
        </FormItem>
     

        <FormItem class="edit-item two actions canle">
          <div class="data">
            <div class="btn canle-btn" @click="canleSave">取消</div>
          </div>
        </FormItem>
        <FormItem class="edit-item two actions">
          <div class="data">
            <div class="btn save-btn" @click="handleSubmit('formValidate')">
              <div>保存信息</div>
              <img class="icon" src="../assets/image/icon/shop-cart-right.svg" />
            </div>
          </div>
        </FormItem>
      </Form>
    </div>
    <add-member-pop
      :showAdd="showAdd"
      @loginCrmSuccess="crmSuccess"
      :showAddText="showAddText"
      v-on:close="colseRules"
    ></add-member-pop>
    <see-member-pop :showSee="showSee" v-on:close="colseRules"></see-member-pop>
  </div>
</template>

<script>
import addMemberPop from "../components/common/AddMemberPop";
import seeMemberPop from "../components/common/SeeMemberPop";
export default {
  name: "UserInfo",
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("此栏为必填项"));
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        callback("手机号格式不正确");
      } else {
        callback();
      }
    };
    return {
      sexs: [
        {
          value: "0",
          label: "未知"
        },
        {
          value: "1",
          label: "先生"
        },
        {
          value: "2",
          label: "女士"
        }
      ],
      showAddText: true,
      showSee: false,
      showAdd: false,
      isMember: false,
      editData: false,
      ishasEmail:false,
      userInfo: {},
      showuserinfo: {},
      dateOptions: {
        disabledDate(date) {
          return date && date.valueOf() > Date.now() - 86400000;
        }
      },
      ruleValidate: {
        firstName: [
          {
            required: true,
            message: "此栏为必填项",
            trigger: "blur"
          }
        ],
        lastName: [
          {
            required: true,
            message: "此栏为必填项",
            trigger: "blur"
          }
        ],
        email: [
          {
            required: true,
            message: "此栏为必填项",
            trigger: "blur"
          },
          { type: "email", message: "请填写正确的邮箱", trigger: "blur" }
        ],
        phone: [{ required: true, validator: validatePhone, trigger: "blur" }],
        birthday: [
          {
            required: true,
            type: "date",
            message: "此栏为必填项",
            trigger: "change"
          }
        ],
        gender: [
          {
            required: true,
            message: "此栏为必填项",
            trigger: "change"
          }
        ]
      }
    };
  },
  props: {
    prartName: {
      type: String,
      default: ""
    }
  },
  components: { addMemberPop, seeMemberPop },
  created() {
    // this.$store.commit("setShowPart", false);
    // this.$store.commit("setPartName", "一日之事");
    document.title = "个人信息" + this.$store.state.titleSuffix;
  },
  mounted() {
    this.getUserInfo();
    this.$gaAction.pageview(document.title, this.$route.path);
    this.$utils.CheckOpenIdExist(this);
  },
  beforeRouteLeave(to, from, next) {
    var state_2 = this.$store.state.RefreshAcountNav;
    this.$store.commit("RefreshAcountNav", !state_2);
    next(true);
  },
  methods: {
    crmSuccess() {
      this.isMember = true;
      this.colseRules();
    },
    colseRules() {
      this.showAdd = false;
      this.showSee = false;
    },
    editUserInfo() {
      var that = this;
      that.editData = true;
    },
    canleSave() {
      this.editData = false;
      this.showuserinfo.birthday = this.formatDate(
        new Date(this.userInfo.birthday)
      );
    },
    formatDate(date) {
      var back = null;
      //设置时间转换格式
      var y = date.getFullYear(); //获取年
      var m = date.getMonth() + 1; //获取月
      m = m < 10 ? "0" + m : m; //判断月是否大于10
      var d = date.getDate(); //获取日
      d = d < 10 ? "0" + d : d; //判断日期是否大10
      back = m + "/" + d + "/" + y;
      return back; //返回时间格式
    },
    dateToString(date) {
      var year = date.getFullYear();
      var month = (date.getMonth() + 1).toString();
      var day = date.getDate().toString();
      if (month.length == 1) {
        month = "0" + month;
      }
      if (day.length == 1) {
        day = "0" + day;
      }
      var dateTime = year + "-" + month + "-" + day;
      return dateTime;
    },
    getUserInfo() {
      var that = this;
      var url = that.$store.state.API.my.getUserInfo;
      this.$http
        .get(url, {
          headers: { tb_token: window.localStorage.getItem("token") }
        })
        .then(res => {
          if (res.data.result) {
            var data = JSON.stringify(res.data.returnData);
            this.showuserinfo = JSON.parse(data);
            this.isMember = res.data.returnData.crmMember;
            this.showuserinfo.birthday = this.formatDate(
              new Date(this.showuserinfo.birthday)
            );
            this.userInfo = res.data.returnData;
            this.ishasEmail=res.data.returnData.email?true:false;
            this.userInfo.birthday = this.formatDate(
              new Date(this.userInfo.birthday)
            );
            this.userInfo.gender = this.userInfo.gender.toString();
            this.$store.commit("setValue", [
              "tb_user_name",
              this.showuserinfo.name
            ]);

            // createTime
          } else if (res.data.returnCode == "005" && !res.data.result) {
            //没有登录 或是失效
            window.localStorage.removeItem("userInfo");
            window.localStorage.removeItem("token");
            let isExitlogin = !this.$store.state.isExitlogin;
            this.$store.commit("UpdateLoginStatus", isExitlogin);
            this.$store.commit("upDateLoveCount", 0);
            this.$store.commit("upDateShopCount", 0);
            this.$router.push({ name: "login" });
            //new
            this.$store.commit("setValue", ["userLogin", false]);
            // this.$store.commit("setValue", ["userLogin", true]);
          } else {
            // this.$Message.error(res.data.message);
          }
        })
        .catch(err => {});
    },
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.updateUserInfo();
        } else {
          // this.$Message.error("Fail!");
        }
      });
    },
    updateUserInfo() {
      var that = this;
      var url = that.$store.state.API.my.updateUserInfo;
      var birthday = this.dateToString(new Date(that.userInfo.birthday));
      var params = {
        id: that.userInfo.id,
        lastName: that.userInfo.name,
        firstName:that.userInfo.firstName,
        email: that.userInfo.email,
        phone: that.userInfo.phoneNumber,
        birthday: birthday,
        gender: parseInt(that.userInfo.gender)
      };
      this.$http
        .post(url, params, {
          headers: {
            tb_token: window.localStorage.getItem("token"),
            "Content-Type": "application/json"
          }
        })
        .then(res => {
          if (res.data.message == "success" && res.data.result) {
            this.editData = false;
            this.$Message.success("保存成功");
            this.getUserInfo();
          } else {
            this.$Message.error("保存失败");
          }
        });
    }
  }
};
</script>
<style lang="less" scoped>
.user-info-container {
  padding: 0 1rem;
  position: relative;

  // border: 0.1rem solid #eaeaea;
  .title {
    width: 100%;
    color: #5c5d5f;
    line-height: 1.6;
    text-align: left;
    padding: 2rem 1rem;
  }
  .add-member {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.4rem 1.8rem;
    border: 0.1rem solid #eaeaea;
    margin-left: 1rem;
    margin-right: 1rem;
    .add-now {
      background: #5b5e60;
      padding: 1rem 1.6rem;
      color: white;
      cursor: pointer;
    }
  }
  .see-member {
    position: absolute;
    right: 3.4rem;
    line-height: 2;
    color: #8e8f8b;
    text-decoration: underline;
    cursor: pointer;
  }
  .content {
    padding: 3rem 1rem 2rem;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    text-align: left;
    &.edit-content {
      padding: 0;
    }

    .item {
      width: 100%;
      display: flex;
      flex-direction: row;
      margin-bottom: 1.6rem;
      color: #8e8f8b;

      .label {
        width: 25%;
        line-height: 2;
      }
      .value {
        font-size: 1.2rem;
        line-height: 2;
        text-transform: uppercase;
      }
    }
    .edit {
      display: flex;
      flex-flow: row wrap;

      .edit-item {
        position: relative;
        width: 100%;
        display: flex;
        color: #959595;
        padding: 0 1rem 2rem;
        .des {
          // width: calc(50% + 1rem);
          padding-top: 3rem;
          // padding-left: 2rem;
          display: flex;
          flex: 0 0 auto;
          align-items: center;
          color: #959595;
          font-size: 1rem;
        }
        .data {
          position: relative;
          display: flex;
          flex-direction: column;
          font-size: inherit;
          flex: 1 0 auto;
          .label {
            margin-bottom: 0.5rem;
            font-size: 1rem;
          }
          /deep/Input {
            color: #959595;
          }
        }
        &.two {
          width: 50%;
          flex: 0 0 auto !important;
        }
        &.three {
          height: 100%;
          margin-top: auto;
          width: 33.33%;
          display: flex;
          flex-direction: column;
          .password-title {
            margin: 1.3rem 0 1.5rem;
            font-size: 1.2rem;
            color: #5c5d5f;
          }
        }
        &.actions {
          margin: 4rem 0 0;
        }
        &.phone-item {
          /deep/.ivu-form-item-content {
            display: flex;
          }
        }
      }
    }
    .edit-btn {
      color: #5c5d5f;
      text-decoration: underline;
      cursor: pointer;
      margin-top: 5.4rem;
    }

    .canle-btn {
      border: 0.1rem solid #959595;
      color: #5c5d5f;
      background-color: #fff;
    }
  }
}
/deep/.ivu-form-item {
  margin-bottom: 0;
}
/deep/.ivu-form-item-content {
  font-size: 1.2rem;
  width: 100%;
  line-height: inherit;
}
@media screen and (max-width: 1024px) {
  .user-info-container {
    padding: 0;
    border: none;
    .title {
      padding: 2rem 2rem;
    }
    .add-member {
      margin: 0 2rem;
    }
    .see-member {
      // top: 0rem;
    }
    .content {
      padding: 3rem 2rem 2rem;

      .edit {
        padding: 2rem;
      }
      .edit-btn {
        margin-top: 2rem;
        margin-bottom: 7rem;
      }
      .namesings.edit-item.two{
        width: 48%!important;
        &.lastName{
           margin-right: 4%;
        }
      }
      .edit .edit-item {
        padding: 0 0 0.7rem;
        .des {
          display: none;
        }
        &.two,
        &.three {
          width: 100%;
        }
        &.actions {
          margin: 0;
        }
        &.canle {
          margin: 2rem 0;
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .user-info-container {
    .title {
      padding: 2rem 2rem;
      display: none;
    }
    .see-member {
      text-align: right;
      padding-top: 1rem;
      line-height: initial;
      padding-right: 3.4rem;
      position: unset;
    }
  }
}
@media screen and (max-width: 375px) {
  .user-info-container .add-member .add-text {
    width: 18rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UserInfo.vue